<section class="with-mat-form-field sip-address">
  <div class="mat-body-1 property-header">{{ "ONSIP_I18N.DOMAIN_TYPE" | translate }}</div>
  <div>
    {{
      ((viewData$ | async)?.domainType === domainType.sipDomain
        ? "ONSIP_I18N.ONSIP_SUBDOMAIN"
        : "ONSIP_I18N.PRIVATE_DOMAIN"
      ) | translate
    }}
  </div>
</section>

<section class="with-mat-form-field sip-address">
  <div class="mat-body-1 property-header">{{ "ONSIP_I18N.DOMAIN_NAME" | translate }}</div>
  <div>{{ (viewData$ | async)?.domainName }}</div>
</section>

<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
    {{ "ONSIP_I18N.EDIT" | translate }}
  </button>
</div>
